// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__6ddTP","title":"AfterBackImages_title__3hA9n","images":"AfterBackImages_images__jphBf"};